import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Bank Account Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const BankAccountView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="bank-accounts"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default BankAccountView;
